import { render, staticRenderFns } from "./string.vue?vue&type=template&id=47d9e21a&scoped=true&"
import script from "./string.vue?vue&type=script&lang=ts&"
export * from "./string.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d9e21a",
  null
  
)

export default component.exports